import ConfirmationDialog from "@/shared/components/domain/confirmation/confirmation-dialog";
import {
  useErrArtefactNotReady,
  useSetErrArtefactNotReadyFromRtk,
} from "@/shared/service-manager/artefact/err-artefact-not-ready";
import { Button } from "@/shared/components/ui/button";
import { ReactElement } from "react";
import { Trash } from "lucide-react";
import { useDeleteAirSamplerMutation } from "@/services/backend/airsamplers/service";
import { RTKQueryErrorAlert } from "@/shared/components/domain/errors/rtk-query-error-alert";

interface DeleteAirSamplerButtonProps {
  airSamplerId: string;
}

export default function DeleteAirSamplerButton({
  airSamplerId,
}: DeleteAirSamplerButtonProps): ReactElement {
  const [deleteAirSampler, { error, reset, isLoading }] =
    useDeleteAirSamplerMutation();
  const { resetNotReadyError } = useErrArtefactNotReady();
  useSetErrArtefactNotReadyFromRtk(error, () => {
    reset();
  });
  const onConfirm = () => {
    if (isLoading) {
      return;
    }

    resetNotReadyError();
    deleteAirSampler({
      id: airSamplerId,
    });
  };

  return (
    <>
      <RTKQueryErrorAlert error={error} />
      <ConfirmationDialog
        trigger={
          <Button className="bg-red-600">
            <Trash />
          </Button>
        }
        title="Luftkeimsammler löschen"
        description="Hiermit wird Luftkeimsammler aus den Stammdaten gelöscht. Der Luftkeimsammler bleibt jedoch bei Prozessen erhalten!"
        onConfirm={onConfirm}
      />
    </>
  );
}
